import { render, staticRenderFns } from "./diamantes.vue?vue&type=template&id=d2a469a2"
import script from "./diamantes.vue?vue&type=script&lang=js"
export * from "./diamantes.vue?vue&type=script&lang=js"
import style0 from "./diamantes.vue?vue&type=style&index=0&id=d2a469a2&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports